import React, { Component } from 'react';
import PropTypes from 'prop-types';

import EmailReportConfigApi from 'apis/EmailReportConfig';
import { SURVEY_EMAIL_INTERVALS } from 'constants/index';
import Toaster from 'components/Toaster';
import BusinessApi from 'apis/Business';
import EmailConfig from 'components/emailConfig/ConfigureEmailView';

import ListUserConfigs from './ListUserConfigs';

class SurveyConfigList extends Component {
  constructor() {
    super();
    this.state = {
      editConfig: {},
      configs: [],
      editMode: false,
    };
  }

  componentDidMount() {
    this.fetchConfig();
  }

  fetchConfig = () => {
    const { businessId } = this.props;
    if (businessId) return this.getBusinessEmailReportConfig(businessId);
  };

  getBusinessEmailReportConfig = businessId => {
    BusinessApi.getBusinessSurveyEmailReportConfigs(businessId)
      .then(({ data }) => {
        this.setState({ configs: data });
      })
      .catch(error => {
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Connection Error'
        );
      });
  };

  toggleEditConfig = config => {
    this.setState({
      editConfig: config,
      editMode: true,
    });
  };

  handleOnCheck = () => {
    const { editConfig } = this.state;
    const _editConfig = { ...editConfig };
    _editConfig.is_active = !_editConfig.is_active;
    this.setState({ editConfig: _editConfig });
  };

  handleOnSelect = email_interval => {
    const { editConfig } = this.state;
    const _editConfig = { ...editConfig, email_interval };

    this.setState({ editConfig: _editConfig });
  };

  updateEmailReportConfig = () => {
    const { editConfig } = this.state;
    const { id, email_interval, is_active } = editConfig;

    EmailReportConfigApi.updateEmailReportConfig(id, email_interval, is_active)
      .then(() => {
        this.setState({ editConfig: {}, editMode: false });
        this.fetchConfig();
        Toaster.getSuccessToaster(
          'check-circle',
          'Email settings saved successfully'
        );
      })
      .catch(error => {
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Error while saving'
        );
      });
  };

  render() {
    const { configs, editConfig, editMode } = this.state;
    const {
      business_name,
      user_name,
      user_role,
      is_active,
      is_unsubscribed,
      email_interval,
    } = editConfig;

    if (editMode) {
      return (
        <EmailConfig
          business_name={business_name}
          userName={user_name}
          userRole={user_role}
          is_active={is_active}
          is_unsubscribed={is_unsubscribed}
          email_interval={email_interval}
          handleOnCheck={this.handleOnCheck}
          handleOnSelect={this.handleOnSelect}
          updateEmailReportConfig={this.updateEmailReportConfig}
          checkboxLabel="Turn on Survey Email Reports"
          intervals={SURVEY_EMAIL_INTERVALS}
          name="survey-report-email-config"
        />
      );
    }

    return (
      <div>
        <p>
          Survey Email Reports help you stay updated with your survey through
          email.
          <br />
          You can select and customize the survey email reports below.
        </p>
        <ListUserConfigs
          configs={configs}
          toggleEditConfig={this.toggleEditConfig}
        />
      </div>
    );
  }
}

SurveyConfigList.defaultProps = {
  businessId: null,
};

SurveyConfigList.propTypes = {
  businessId: PropTypes.string,
};

export default SurveyConfigList;



// WEBPACK FOOTER //
// ./src/components/emailConfig/list/SurveyConfigList.js